/* BI-02 · CARD-BACKED TRIAL
   Card required, renewal amount and date shown before confirmation, and
   cancellation two clicks away — no call, no justification. */
import { Button, Card, KV, Note } from '@/ui'
import { Head, useBill } from './ParamShell'

export default function BI02Essai() {
  const t = useBill().trial
  return (
    <section data-frame="BI-02" style={{ display: 'grid', gap: 14 }}>
      <Head title="Essayez le parcours complet" />
      <Card>
        <KV rows={[
          ['Offre', <><strong>{t.plan}</strong> · <strong>{t.cycle}</strong>{t.cycleTail}</>],
          ['Essai', <><strong>{t.days}</strong>{t.card}</>],
          ['Renouvellement', <><strong>{t.renewAmount}</strong>{t.renewDate}</>],
          ['Votre essai', t.timeline],
        ]} />
      </Card>
      <Note tone="ok">
        Annulez avant la fin si ce n’est pas pour vous — l’annulation est à deux clics, sans appel
        ni justification.
      </Note>
      <div><Button variant="primary">Ajouter ma carte et démarrer l’essai</Button></div>
      <p className="t-body">
        « Commencer gratuitement » reste séparé et sans carte. Un contrat 3 ans n’a pas d’essai —
        démo assistée à la place.
      </p>
    </section>
  )
}
